import { Record } from 'immutable';

const FeedbackRecord = Record({
  strengths: undefined,
  weaknesses: undefined,
  performance: undefined,
  actionPlan: undefined,
});

class Feedback extends FeedbackRecord { }

Feedback.create = (data) => new FeedbackRecord(data);

export default Feedback;



// WEBPACK FOOTER //
// ./data/Feedback/model.js